// components/EnrollForm/StepPayment.jsx
import {
  Box,
  Typography,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";
import axios from "axios";

export default function StepPayment({
  BASE_URL,
  student,
  formData,
  setFormData,
  selectedCourse,
  selectedTutorCourse,
  installmentAmount,
  fullPaymentAmount,
  setSnackbar,
  onSuccess,
}) {
  // const getAdjustedPrice = (price) =>
  //   formData.deliveryMethod === "online"
  //     ? Math.floor(Number(price || 0) / 2)
  //     : Number(price || 0);

  const getAdjustedPrice = (price) => Number(price || 0);

  const handleSubmit = async () => {
    try {
      // Validate
      if (
        !formData.course ||
        !formData.selectedTutor ||
        !formData.paymentPlan ||
        !formData.deliveryMethod
      ) {
        setSnackbar({
          open: true,
          message: "Please complete all steps before payment.",
          severity: "warning",
        });
        return;
      }

      if (!student || !student.email) {
        setSnackbar({ open: true, message: "Student not authenticated.", severity: "error" });
        return;
      }

      const initRes = await axios.post(`${BASE_URL}/api/students/initialize-course-enrollment-payment`, {
        student_id: student.id,
        tutor_course_id: formData.selectedTutor,
        course_id: formData.course,
        location: formData.location,
        delivery_method: formData.deliveryMethod,
        payment_plan: formData.paymentPlan,
        office_id: formData.officeId || null,
        email: student.email,
        name: student.name,
      });

      const authorizationUrl = initRes.data?.authorization_url;
      if (!authorizationUrl) {
        setSnackbar({
          open: true,
          message: initRes.data?.message || "Unable to initialize payment.",
          severity: "error",
        });
        return;
      }

      window.location.href = authorizationUrl;
    } catch (err) {
      console.error("Unexpected error:", err);
      setSnackbar({ open: true, message: "An unexpected error occurred.", severity: "error" });
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Payment Summary
      </Typography>

      <Box sx={{ mb: 3 }}>
        <Typography>
          <strong>Course:</strong> {selectedCourse?.name}
        </Typography>
        <Typography>
          <strong>Tutor:</strong> {selectedTutorCourse?.tutor_name || "Not selected"}
        </Typography>
        <Typography>
          <strong>Mode of Learning:</strong>{" "}
          {/* {formData.deliveryMethod === "online" ? "Online (50% discount)" : "On-Site"} */}
          {formData.deliveryMethod === "online" ? "Online" : "On-Site"}
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Typography variant="h6">
          Total: ₦{getAdjustedPrice(selectedCourse?.price).toLocaleString()}
          {/* {formData.deliveryMethod === "online" && (
            <span
              style={{
                textDecoration: "line-through",
                marginLeft: 8,
                color: "#999",
                fontSize: "0.9rem",
              }}
            >
              ₦{Number(selectedCourse?.price || 0).toLocaleString()}
            </span>
          )} */}
        </Typography>
      </Box>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Payment Plan</InputLabel>
        <Select
          name="paymentPlan"
          value={formData.paymentPlan}
          onChange={(e) => setFormData((p) => ({ ...p, paymentPlan: e.target.value }))}
          label="Payment Plan"
        >
          <MenuItem value="installment">
            Installment (₦{Number(installmentAmount).toLocaleString()})
          </MenuItem>
          <MenuItem value="full">Full (₦{Number(fullPaymentAmount).toLocaleString()})</MenuItem>
        </Select>
      </FormControl>

      <FormControlLabel
        control={
          <Checkbox
            checked={formData.termsAccepted}
            onChange={(e) => setFormData((prev) => ({ ...prev, termsAccepted: e.target.checked }))}
            required
          />
        }
        label={
          <Typography variant="body2">
            I agree to the{" "}
            <Typography
              component="a"
              href="/terms"
              target="_blank"
              // rel="noopener noreferrer"
              sx={{
                color: "primary.main",
                textDecoration: "underline",
                cursor: "pointer",
                "&:hover": { textDecoration: "none" },
              }}
            >
              terms and conditions
            </Typography>
          </Typography>
        }
        sx={{ mb: 2 }}
      />

      <Button
        variant="contained"
        size="large"
        fullWidth
        disabled={!formData.termsAccepted}
        onClick={handleSubmit}
      >
        Pay ₦
        {(
          formData.paymentPlan === "installment" ? installmentAmount : fullPaymentAmount
        ).toLocaleString()}
      </Button>
    </Box>
  );
}
